import { render, staticRenderFns } from "./RoutesCrud.vue?vue&type=template&id=2e40d595"
import script from "./RoutesCrud.vue?vue&type=script&lang=js"
export * from "./RoutesCrud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports